<template>
  <div>
    <b-modal :visible="modal" @hide="resetModalAndClose" v-b-modal="modalName">
      <template>
        <div slot="modal-title">
        </div>
        <b-alert dismissible
                 @dismissed="clearScreen"
                 v-model="isApiCallComplete"
                 :variant="isSuccess ?('success') :('danger')">
          {{
            (isSuccess && isApiCallComplete) ? ($t('submitUserSuccessMessage')) : ($t('submitUserFailureMessage'))
          }}
        </b-alert>
      </template>
      <div class="popup-container">
        <div class="input-section">
          <template>
            <h6>Activate Users for Unicon</h6>
            <div>
              <div>
                <fieldset class="form-group">
                  <legend style="text-align: left;">{{$t('FirstName')}}</legend>
                  <div class="select-container">
                    <b-input v-model="FirstName"
                             class="style-input"
                             size="md"
                             :placeholder="enterFirstName" />
                  </div>
                </fieldset>
              </div>
              <div>
                <fieldset class="form-group">
                  <legend style="text-align: left;">{{$t('LastName')}}</legend>
                  <div class="select-container">
                    <b-input v-model="LastName"
                             class="style-input"
                             size="md"
                             :placeholder="enterLastName" />
                  </div>
                </fieldset>
              </div>
              <div>
                <fieldset class="form-group">
                  <legend style="text-align: left;">{{$t('Email')}}</legend>
                  <div class="select-container">
                    <b-input v-model="Email"
                             class="style-input"
                             size="md"
                             :placeholder="enterEmail" />
                  </div>
                </fieldset>
              </div>
              <div v-if="loading" class="loading-container">
                <i class="fa fa-spinner loading-animation fa-3x" />
              </div>
              <div>
                <b-button variant="primary" class="rdm-btn" @click="upsertUniconCustomer">{{ $t('submit') }}</b-button>
              </div>
            </div>
          </template>
        </div>
        <div class="divider"></div>
        <div class="user-list-section">
          <template>
            <h6>Active Users</h6>
            <table class="rdm-table">
              <tbody>
                <tr v-for="(user, index) in tableData" :key="index">
                  <td style="margin-left:5px">
                    <p class="firstNameRow"> {{ user.FirstName }} {{ user.LastName }}</p>
                    <p class="emailRow"> {{ user.Username }} </p>
                    <!--<input v-else v-model="tableData[index]" @blur="saveRow(index)" />-->

                  </td>
                  <td style="margin:0px">
                    <b-button class="rdm-table-btn" @click="editRow(user)"><i style="color: #2071c5" class='fa fa-edit'></i></b-button>                    
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
      </div>
      <div slot="modal-footer" />
    </b-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
  import SurveyModal from './SurveyModal'
  import Loading from './Loading'

  export default {
    name: 'UniconCustomerModal',
    components: {
      'loading': Loading,
      'typeahead': VueBootstrapTypeahead,
      'survey-modal': SurveyModal
    },
    props: {
      modal: { type: Boolean, required: true },
      closeModal: { type: Function, required: true },
      openModal: { type: Function, required: true },
      customHeader: { type: String, default: 'Manage Licenses - Unicon' }
    },
    data () {
      return {
        FirstName: '',
        LastName: '',
        Email: '',
        editing: {},
        isSuccess: false,
        loading: false,
        isApiCallComplete: false,
        tableData: []
      }
    },
    mounted () {
      this.getUserListForUnicon()
    },
    created () {
      Vue.AppInsights.trackPageView('Unicon Customer page', '/uniconCustomer')
    },
    updated () {
    },
    computed: {
      allocateTitle () {
        return this.$t('ManageLicensesUnicon')
      },
      enterFirstName () {
        return this.$t('enterFirstName')
      },
      enterLastName () {
        return this.$t('enterLastName')
      },
      enterEmail () {
        return this.$t('enterEmail')
      }
    },
    methods: {
      getUserListForUnicon () {
        this.bottle.get(this.UrlBuilder.getUserListForUnicon(this.$store.getters.person.customerId))
          .then(({ data: Data }) => {
            this.tableData = Data.OrganizationUsers
          })
          .catch((error) => {
            this.loading = false
            this.hasApiCallFailed = true
            this.isApiCallDone = true
            this.loggly.log({
              errorMessage: 'Failed to get UserList For Unicon',
              errorObject: error,
              errorStack: error.stack
            })
          })
      },
      upsertUniconCustomer () {
        this.loading = true
        const Request = {
          firstname: this.FirstName,
          lastname: this.LastName,
          email: this.Email,
          softlimitationdate: Math.floor(new Date(this.$store.getters.UniconLicDetails[0].Expiry).getTime() / 1000),
          deviceLimit: this.$store.getters.UniconLicDetails[0].Quantity,
          organizationId: this.$store.getters.person.customerId
        }

        this.bottle.post(this.UrlBuilder.updateUserListForUnicon(), { ...Request })
          .then(({ data }) => {
            if (data) {
              this.isSuccess = true
              this.tableData = data.OrganizationUsers
            } else {
              this.isSuccess = false
            }
          })
          .catch((error) => {
            this.loading = false
            this.loggly.log({
              errorMessage: `Failed to save user`,
              errorObject: error,
              errorStack: error.stack
            })
          })
          .finally(() => {
            this.isApiCallComplete = true
            this.loading = false
          })
      },
      clearScreen () {
        this.isSuccess = false
        this.isApiCallComplete = false
        this.FirstName = ''
        this.LastName = ''
        this.Email = ''
      },
      resetModalAndClose () {
        this.loading = false
        this.closeModal()
        this.clearScreen()
        this.getUserListForUnicon()
      },
      editRow (user) {
        this.FirstName = user.FirstName
        this.LastName = user.LastName
        this.Email = user.Username
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../styles/variables.scss';

  button:focus {
    box-shadow: none !important;
    border: none;
    outline: 0;
  }

  .firstNameRow {
      font-size: 13px;
      font-weight:bold;
      margin-bottom: 0px;
  }
  .emailRow {
    font-size: 10px;
    margin-bottom: 2px;
  }
  .popup-container {
      display: grid;
      grid-template-columns: 1fr 1px 1fr;
      gap: 20px;
      padding: 10px;      
      border-radius: 10px;
  }

  .input-section {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
  }

  .user-list-section {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
  }

  .divider {
      background-color : #ccc;
      height: 100%;
      width: 1px;
  }

  a {
    text-decoration: none !important;
  }

  .rdm-btn {
    display: inline-block;
    border-radius: 50px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .rdm-table-btn {
    display: inline-block;
    border-radius: 10px;
    background-color: white !important;
    border-color: white !important;
  }

  .rdm-table {
    width: 100%;
    border-collapse: separate;
    z-index: 1;
  }

  .rdm-table thead tr > th:first-child {
    width: 5%;
  }

  .rdm-table thead tr > th:nth-child(2) {
    width: 55%;
    border-right: 1px solid #dee2e6;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .rdm-table thead tr > th:nth-child(3) {
    width: 20%;
  }

  .rdm-table thead tr > th:last-child {
    width: 10%;
    text-align: right;
  }

  .rdm-table thead,
  .rdm-table thead > tr {
    min-height: 20px;
  }

  .rdm-table th {
    background: $lightGray;
    border-color: $lightGray;
    font-weight: 200;
    padding: 10px 7px;
  }

  .rdm-table th:first-child,
  .rdm-table td:first-child {
    border-left: 1px solid #dee2e6;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    padding-left: 5px;
    padding-top: 5px;
  }

  .rdm-table th:last-child,
  .rdm-table td:last-child {
    border-right: 1px solid #dee2e6;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;    
  }

  .rdm-table th,
  .rdm-table td {
    border-top: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
  }

  .modal-input {
    display: inline-block;
    width: 48%;
    margin-top: 12px;
  }

  .loading-container {
    padding-top: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    display: inline-block;
    width: 10%;
    vertical-align: middle
  }

  .loading-animation {
    animation: loading-spin infinite 1s linear;
  }
 

  @keyframes loading-spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UniconCustomerModal.vue